module.exports = __webpack_public_path__ + "img/ctrl-rx-theta-stub-+i.9c3d01a7.svg";